<template>
    <div>
        <div class="crumbs mcrumb-self">
            <el-breadcrumb separator="-">
                <el-breadcrumb-item>
					<i class="el-icon-files"></i><span>档案整理</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>档案成册</span></el-breadcrumb-item>
			</el-breadcrumb>
        </div>
        <!-- <el-divider></el-divider> -->

        <div class="container" style="padding: 0px 20px 10px 20px;">
            <div style="display: flex;padding-top: 12px;">
                <div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">成册状态</label></div>
                <div class="voucher-img-div" v-for="(imgObj, index) in archiveVolumeStatusImgList " :key="index">
                    <img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="archiveVolumeStatusImgClickFun($event, index)">
                </div>
            </div>
            <el-divider></el-divider>
            <div class="my-container">
                <div>
                    <el-row>
                        <div style="display: flex;float: left">
                            <el-button plain @click="autoVolumeSettingClickFun()">一键成册设置</el-button>
                            <el-button plain @click="autoBookClickFun">一键成册</el-button>
                            <el-button type="primary" @click="manualVolumeClickFun('1', '')">手工成册</el-button>
                            <el-button plain @click="cancelVolumeClickFun()">取消成册</el-button>
                            <el-button plain @click="setBookedClickFun()">置为已成册</el-button>
                            <el-button plain @click="setBookingClickFun()">置为成册中</el-button>
                            <!-- <el-button plain @click="volumeLevelClickFun()">册密级修改</el-button> -->
                        </div>
                        <el-input v-model="archiveVolumeSearchName" placeholder="册号、所属实体、成册人" style="width:350px;float: right;" prefix-icon="el-icon-search" />
                    </el-row>
                </div>
                <div style="padding-top: 10px;">
                    <el-table ref="archiveVolumeTable" :data="archiveVolumeTableData" style="width: 100%;" border stripe class="table" height="600px" @row-click="(row) => clickRowByChecked('archiveVolumeTable', row)">
                        <el-table-column type="selection" width="50"></el-table-column>
                        <el-table-column prop="id" v-if="showColumn == false"></el-table-column>
                        <el-table-column prop="archivesType" label="档案类别" align="center">
                            <template>
                                <span>会计凭证</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bookNo" label="册号" align="center"></el-table-column>
                        <el-table-column prop="updateTime" label="成册日期" sortable :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
                        <el-table-column prop="companyName" label="所属实体" sortable></el-table-column>
                        <el-table-column prop="voucherNo" label="起止记账凭证号" sortable>
                            <template slot-scope="scoped">
                                <span>{{scoped.row.voucherNoStart}}</span>
                                <span v-if="scoped.row.voucherNoStart && scoped.row.voucherNoEnd"> - </span>
                                <span>{{scoped.row.voucherNoEnd}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="secretLevel" width="100" label="册密级" sortable align="center">
                            <template slot-scope="scoped">
                                {{scoped.row.secretLevel}}级
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" width="120" label="当前状态" sortable align="center">
                            <template slot-scope="scoped">
                                <div v-for="(imgObj, index) in formatArchiveVolumeStatusImgList" :key="index">
                                    <img v-if="imgObj.code == scoped.row.status" :src="require('../../../assets/img/' + imgObj.name + '.png')">
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="operator" label="成册人" sortable></el-table-column>
                        <el-table-column prop="operate" label="操作" width="160" align="center" fixed="right">
                            <template slot-scope="scoped">
                                <el-button size="small" type="text" @click="manualVolumeClickFun('2', scoped.row)">编辑成册</el-button>
                                <el-button size="small" type="text" @click="viewVolumeDetails(scoped.row.id)">查看更多</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh('volumepwm')"></el-link>
                        <el-pagination
                            @size-change="(val) => handleSizeChange('volumepwm', val)"
                            @current-change="(val) => handleCurrentChange('volumepwm', val)"
                            :current-page="volumepwm.page"
                            :page-size="volumepwm.limit"
                            :page-sizes="volumepwm.limits"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="volumepwm.count">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 一键成册设置 dialog -->
        <el-dialog title="一键成册设置" :visible.sync="autoVolumeSettingDialogVisible" width="35%">
            <div class="custom-dialog" style="height: 170px;">
                <div style="line-height: 30px;font-weight: bold;">会计凭证类</div>
                <el-row type="flex" style="height: 50px;line-height: 50px;">
                    <el-col :span="6" style="text-align: right;padding-right: 20px;">1、挂接组件</el-col>
                    <el-col :span="18">
                        <span>根据已分组的</span>
                        <el-select v-model="volumeConfig" placeholder="请选择" style="width: 150px;padding: 0px 10px;">
                            <el-option
                                v-for="item in volumeConfigData"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <span>顺序成册</span>
                    </el-col>
                </el-row>
                <el-row type="flex" style="height: 50px;line-height: 50px;">
                    <el-col :span="6" style="text-align: right;padding-right: 20px;">2、册内份数</el-col>
                    <el-col :span="18" style="display: flex;">
                        ≤
                        <el-input v-model="volumeCount" placeholder="单行输入" style="width: 150px;padding: 0px 10px;"></el-input>
                        份
                    </el-col>
                </el-row>
                <div style="text-align: center;padding-top: 10px;">
                    <el-button type="primary" @click="doSettingBook"  style="width: 80px;">设置</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 手工成册 dialog -->
        <el-dialog title="手工成册" :visible.sync="manualVolumeDialogVisible" width="850px" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="manualVolumeForm" ref="manualVolumeForm">
                    <div style="padding: 5px 0px 15px 0px;">
                        <el-button type="primary" @click="tempSaveManualVolumeClickFun">置为成册中</el-button>
                        <el-button type="primary" @click="saveManualVolumeClickFun">置为已成册</el-button>
                    </div>
                    <div class="mv-voucher-container">
                        <el-row class="mv-voucher-header">
                            <span>会计凭证封面</span>
                        </el-row>
                        <el-row type="flex" style="padding-bottom: 15px;">
                            <el-col :span="12" style="text-align: left;">
                                <span>单位名称</span>
                                <el-select v-model="manualVolumeForm.companyId" placeholder="请选择" style="padding: 0px 15px;" :disabled="disabledCompanyName" @change="companySelectChange">
                                    <el-option
                                        v-for="item in userCheckCompanyData"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-button type="primary" @click="manualVolumeHookGroupClickFun()">挂接分组</el-button>
                                <el-input v-model="manualVolumeForm.id" v-if="showColumn == false"></el-input>
                                <el-input v-model="manualVolumeForm.opType" v-if="showColumn == false"></el-input>
                            </el-col>
                            <el-col :span="12" style="text-align: right;">
                                <span>凭证名称</span>
                                <el-select v-model="manualVolumeVoucherName" placeholder="请选择" style="padding-left: 15px;" disabled>
                                    <el-option v-for="item in this.archiveVolumeVoucherNameList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <div class="mv-voucher-body">
                            <el-row type="flex" class="mv-voucher-row">
                                <el-col :span="4" class="mv-voucher-title">
                                    时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间
                                </el-col>
                                <el-col :span="20">
                                    <div style="text-align: center;">
                                        自
                                        <span class="mv-voucher-content-span">
                                            <span v-if="manualVolumeCoverFormData.voucherBeginDate">{{ manualVolumeCoverFormData.voucherBeginDate.substr(0, 4) }}</span>
                                        </span>
                                        年
                                        <span class="mv-voucher-content-span">
                                            <span v-if="manualVolumeCoverFormData.voucherBeginDate">{{ manualVolumeCoverFormData.voucherBeginDate.substr(5, 2) }}</span>
                                        </span>
                                        月
                                        <span class="mv-voucher-content-span">
                                            <span v-if="manualVolumeCoverFormData.voucherBeginDate">{{ manualVolumeCoverFormData.voucherBeginDate.substr(8, 2) }}</span>
                                        </span>
                                        日起至
                                        <span class="mv-voucher-content-span">
                                            <span v-if="manualVolumeCoverFormData.voucherEndDate">{{ manualVolumeCoverFormData.voucherEndDate.substr(0, 4) }}</span>
                                        </span>
                                        年
                                        <span class="mv-voucher-content-span">
                                            <span v-if="manualVolumeCoverFormData.voucherEndDate">{{ manualVolumeCoverFormData.voucherEndDate.substr(5, 2) }}</span>
                                        </span>
                                        月
                                        <span class="mv-voucher-content-span">
                                            <span v-if="manualVolumeCoverFormData.voucherEndDate">{{ manualVolumeCoverFormData.voucherEndDate.substr(8, 2) }}</span>
                                        </span>
                                        日止
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row type="flex" class="mv-voucher-row">
                                <el-col :span="4" class="mv-voucher-title">
                                    册&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数
                                </el-col>
                                <el-col :span="20">
                                    <el-row type="flex">
                                        <el-col :span="8" class="mv-voucher-content">
                                            共
                                            <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.bookTotal}}</span>
                                            册
                                        </el-col>
                                        <el-col :span="6" class="mv-voucher-content" style="text-align: center;background-color: #f8f8f8;padding-left: 20px;box-sizing: border-box;">
                                            册&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;次
                                        </el-col>
                                        <el-col :span="10" class="mv-voucher-content" style="border-right: none;">
                                            本册是第
                                            <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.bookIndex}}</span>
                                            册
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row type="flex" class="mv-voucher-row">
                                <el-col :span="4" class="mv-voucher-title">
                                    记账凭证
                                </el-col>
                                <el-col :span="20" style="text-align: center;">
                                    本册自第
                                    <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.voucherBeginNo}}</span>
                                    号至第
                                    <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.voucherEndNo}}</span>
                                    号共
                                    <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.accVoucherTotal}}</span>
                                    张
                                </el-col>
                            </el-row>
                            <el-row type="flex" class="mv-voucher-row">
                                <el-col :span="4" class="mv-voucher-title">
                                    附&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;件
                                </el-col>
                                <el-col :span="20">
                                    <el-row type="flex">
                                        <el-col :span="12" class="mv-voucher-content">
                                            共
                                            <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.oriVoucherTotal}}</span>
                                            张
                                        </el-col>
                                        <el-col :span="12"  class="mv-voucher-content" style="border-right: none;">
                                            本册凭证合计
                                            <span class="mv-voucher-content-span">{{manualVolumeCoverFormData.attachmentTotal}}</span>
                                            张
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row type="flex" style="line-height: 88px;">
                                <el-col :span="4" class="mv-voucher-title">
                                    备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注
                                </el-col>
                                <el-col :span="20">
                                    <el-form-item style="padding: 10px 5px 15px 5px;">
                                        <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="manualVolumeForm.book.remark"></el-input>
                                        <div class="el-form-item__error" v-if="this.showRemarkMsg == true">备注不得超过50个字符</div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="mv-voucher-footer">
                            <el-row type="flex">
                                <el-col :span="8" style="padding-left: 15px;">
                                    会计主管
                                    <span class="mv-voucher-footer-span">{{ manualVolumeCoverFormData.treasurer }}</span>
                                </el-col>
                                <el-col :span="8" style="text-align: center;">
                                    装订人
                                    <span class="mv-voucher-footer-span">{{ manualVolumeCoverFormData.bookedUser }}</span>
                                </el-col>
                                <el-col :span="8" style="text-align: right;padding-right: 15px;">
                                    <span class="mv-voucher-footer-span">
                                        <span v-if="manualVolumeCoverFormData.bookedDate">{{ manualVolumeCoverFormData.bookedDate.substr(0, 4) }}</span>
                                    </span>
                                        年
                                        <span class="mv-voucher-footer-span">
                                             <span v-if="manualVolumeCoverFormData.bookedDate">{{ manualVolumeCoverFormData.bookedDate.substr(5, 2) }}</span>
                                        </span>
                                        月
                                        <span class="mv-voucher-footer-span">
                                             <span v-if="manualVolumeCoverFormData.bookedDate">{{ manualVolumeCoverFormData.bookedDate.substr(8, 2) }}</span>
                                        </span>
                                        日
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-form>
            </div>
        </el-dialog>

        <!-- 手工成册 -  挂接组件 dialog -->
        <el-dialog title="挂接分组" :visible.sync="manualVolumeHookGroupDialogVisible" width="1200px" :close-on-click-modal="false" :before-close="manualVolumeHookGroupDialogClose">
            <div class="custom-dialog">
                <el-row type="flex" style="padding-bottom: 10px;">
                    <el-col :span="4">
                        <el-button type="primary" style="width: 80px;" @click="saveManualVolumeHookGroupClickFun()">保存</el-button>
                    </el-col>
                    <el-col :span="20" style="text-align: right;">
                        <el-input v-model="manualVolumeHookGroupSearchName" placeholder="系统组号、记账凭证号" style="width:350px;margin-bottom:5px" prefix-icon="el-icon-search" @keyup.native="fuzzyQueryManualVolumeGroupData"/>
                    </el-col>
                </el-row>
                <div style="display: flex;">
                    <div style="width: 40%;padding-right: 15px;">
                        <div class="mv-hook-group-container">
                            <ul style="width: 98%;">
                                <div v-for="(group, index) in manualVolumeDetailGroupForm.manualVolumeDetailGroupData" :key="index">
                                    <li style="width: 100%;" @click="manualVolumeDetailGroupNodeClickFun(index)" :id="manualVolumeDetailGroupNodeId + index">
                                        <div style="display: flex;padding: 15px 0px 0px 15px;width: 100%;">
                                            <div class="mv-hook-group-ind" style="width: 5%;">{{ index + 1 }}</div>
                                            <div class="mv-hook-group-content" style="width: 95%;">
                                                <div style="display: flex;">
                                                    <div>系统组号<span style="padding-left: 15px;">{{group.groupNo}}</span></div>
                                                </div>
                                                <div style="display: flex;">
                                                    <div style="width: 50%;">记账凭证号<span style="padding-left: 15px;">{{group.voucherNo}}</span></div>
                                                    <div style="width: 50%;">分组日期<span style="padding-left: 15px;">{{group.groupDate}}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </div>
                            </ul>   
                        </div>
                    </div>
                    <div style="width: 5%;text-align: center;">
                        <div style="padding-top: 150px">
                            <el-button plain @click="moveLeft()"><i class="el-icon-d-arrow-left" style="font-size: 14px;font-weight: bold;"></i></el-button>
                        </div>
                        <div style="padding-top: 50px;">
                            <el-button plain @click="moveRight()"><i class="el-icon-d-arrow-right" style="font-size: 14px;font-weight: bold;"></i></el-button>
                        </div>
                    </div>
                    <div style="width: 55%;padding-left: 15px;">
                        <el-table ref="manualVolumeHookGroupTable" :data="manualVolumeHookGroupTableData" style="width: 100%;" border stripe class="table" height="420px" @row-click="(row) => clickRowByChecked('manualVolumeHookGroupTable', row)" :row-class-name="tableRowClassName">
                            <el-table-column type="selection" width="50"></el-table-column>
                            <el-table-column prop="id" v-if="showColumn == false"></el-table-column>
                            <el-table-column prop="groupNo" label="系统组号" align="center">
                                <template slot-scope="scoped">
                                    <el-link :underline="false" @click="viewGroupDetailsClickFun(scoped.row.id)" type="primary">{{ scoped.row.groupNo }}</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column prop="voucherNo" label="记账凭证号" sortable></el-table-column>
                            <el-table-column prop="createTime" label="分组日期" sortable :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh('manualpwm')"></el-link>
                            <el-pagination
                                @size-change="(val) => handleSizeChange('manualpwm', val)"
                                @current-change="(val) => handleCurrentChange('manualpwm', val)"
                                :current-page="manualpwm.page"
                                :page-size="manualpwm.limit"
                                :page-sizes="manualpwm.limits"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="manualpwm.count">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 册密级修改 dialog -->
        <el-dialog title="密级修改" :visible.sync="volumeLevelDialogVisible" width="25%" :close-on-click-modal="false">
            <div class="custom-dialog" style="height: 130px;">
                <el-form :model="volumeLevelForm" ref="volumeLevelForm">
                    <div style="line-height: 35px;">当前共选中<span style="color: #409EFF;padding: 0px 5px;">{{ volumeLevelForm.count }}</span>册，</div>
                    <div style="line-height: 35px;">
                        <span>密级统一修改为</span>
                        <el-select v-model="volumeLevelForm.volumeLevel" placeholder="请选择" style="width: 150px;padding: 0px 10px;" @change="volumeLevelSelectChange">
                            <el-option
                                v-for="item in volumeLevelData"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <div class="el-form-item__error" style="top: 63%;left: 130px;" v-if="this.showLevelMsg == true">密级不能为空</div>
                    </div>
                    <div style="text-align: center;padding-top: 25px;">
                        <el-button type="primary" style="width: 80px;" @click="saveVolumeLevelDataClickFun()">确定</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>

        <!-- 查看文件明细 -->
        <custom ref="voucher" v-bind:voucher="voucher"></custom>
    </div>
</template>
<script>
    import https, { fetchPost } from '../../../../https.js';
    import voucher from '../common/custom.vue';

    export default {
        data() {
            return {
                volumepwm: JSON.parse(JSON.stringify(this.pageobj)),
                manualpwm: JSON.parse(JSON.stringify(this.pageobj)),
                showColumn: true,
                archiveVolumeStatusImgList: JSON.parse(JSON.stringify(this.archiveBookStatusList)),
                formatArchiveVolumeStatusImgList: JSON.parse(JSON.stringify(this.archiveBookStatusList)),
                archiveVolumeSearchName: '',
                archiveVolumeTableData: [],
                manualVolumeDialogVisible: false,
                manualVolumeVoucherName: '1',   //  手工成册 - 凭证名称
                userCheckCompanyData: [],   //  用户勾选公司
                disabledCompanyName: false,
                showRemarkMsg: false,
                manualVolumeForm: {
                    id: '', //  册ID
                    opType: '', //  操作类型：1 - 手工成册 2 - 编辑成册
                    companyId: '',  //  实体ID
                    groupIdList: [],    //  组ID list
                    book: {}    //  册信息
                },
                manualVolumeCoverFormData: {
                    companyName: '',voucherName:'',voucherBeginDate:'',voucherEndDate:'',bookTotal:'',bookIndex:'',voucherBeginNo:'',voucherEndNo:'',
                    oriVoucherTotal:'',accVoucherTotal:'',attachmentTotal:'',remark:'',treasurer:'',bookedUser:'',bookedDate:''
                },  //  册封面数据
                manualVolumeHookGroupDialogVisible: false,  //  手工成册 - 挂接分组
                manualVolumeHookGroupSearchName: '',
                manualVolumeHookGroupTableData: [],
                backupManualVolumeHookGroupTableData: [],
                manualVolumeDetailGroupNodeId: 'detail_node_',
                manualVolumeDetailGroupForm: {
                    manualVolumeDetailGroupData: [],    //  册内组明细
                },
                backupManualVolumeDetailGroupData: [],  
                volumeConfig: '',
                volumeConfigData: [{
                    value: '1',
                    label: '记账凭证编号'
                },
                {
                    value: '2',
                    label: '系统组号'
                }],
                volumeCount: '',
                autoVolumeSettingDialogVisible: false,
                showLevelMsg: false,
                volumeLevelDialogVisible: false,
                volumeLevelData: JSON.parse(JSON.stringify(this.secretLevelList)),
                volumeLevelForm: {
                    count: '',
                    volumeLevel: '',
                    ids: ''
                },
                currUserSecretLevel: '',    //  当前用户密级权限
                voucher: {
				    vftype: '',	//	凭证类型：1：记账凭证 2：原始凭证
                    vid: ''	//	凭证ID
                }
            }
        },
        created: function() {
            this.getArchiveBookData();
            this.getBookSettingConfig();
        },
        methods: {
            refresh(pwmName) {
                if(pwmName == 'volumepwm') {
                    this.getArchiveBookData();
                } else if(pwmName == 'manualpwm') {
                    this.getManualVolumeHookGroupData();
                }
            },
            handleSizeChange(pwmName, val) {
                this[pwmName].limit = val;
                if(pwmName == 'volumepwm') {
                    this.getArchiveBookData();
                } else if(pwmName == 'manualpwm') {
                    this.getManualVolumeHookGroupData();
                }
            },
            handleCurrentChange(pwmName, val) {
                this[pwmName].page = val;
                if(pwmName == 'volumepwm') {
                    this.getArchiveBookData();
                } else if(pwmName == 'manualpwm') {
                    this.getManualVolumeHookGroupData();
                }
            },
            clickRowByChecked(refTableName, row) {
                this.$refs[refTableName].toggleRowSelection(row);
            },
            tableRowClassName({row, rowIndex}) {
                row.rowIndex = rowIndex;
            },
            archiveVolumeStatusImgClickFun(event, index) {	//	分组状态点击选中/取消选中效果
                let imgObj = event.currentTarget;
                let imgName = imgObj.name;
                if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
                    this.archiveVolumeStatusImgList[index].name = imgName + '-h';
                } else {
                    this.archiveVolumeStatusImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
                }

                let checkVolumeStatusList = [];
                this.archiveVolumeStatusImgList.forEach(typeObj => {
                    if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
                        checkVolumeStatusList.push(typeObj.code);
                    }
                });
                if(!checkVolumeStatusList || checkVolumeStatusList.length == 0) {
                    this.$message.error('至少需要展示一个成册状态！');
                    this.archiveVolumeStatusImgList[index].name = imgName;
                    return false;
                }
                //  load table
                this.getArchiveBookData();
            },
            companySelectChange(newVal) { //  手工成册 - 单位名称 combo select change
                this.getManualVolumeHookGroupData();
            },
            async getCheckVolumeCondition() {
                //	勾选的成册状态
                let checkVolumeStatusList = [];
                this.archiveVolumeStatusImgList.forEach(typeObj => {
                    if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
                        checkVolumeStatusList.push(typeObj.code);
                    }
                });
                this.volumepwm.search = { 'bookStatusList': checkVolumeStatusList.join(',') };
            },
            async getArchiveBookData() {
                this.getCheckVolumeCondition();
                this.volumepwm.likeSearch = this.archiveVolumeSearchName;
                await fetchPost('/collation/book/getCollationBookList', this.volumepwm).then(res => {
                    this.archiveVolumeTableData = res.data.data;
                    this.volumepwm.count = res.data.count;
                }, error => {
                    this.$message.error('加载成册信息失败： ' + error);
                });
            },
            async getManualVolumeHookGroupData() {  //  手工成册 - 挂接分组 组信息
                this.manualpwm.likeSearch = this.manualVolumeHookGroupSearchName;
                this.manualpwm.search = { 'companyId': this.manualVolumeForm.companyId };
                fetchPost('/collation/book/getCollationBookGroupList', this.manualpwm).then(res => {
                    this.manualVolumeHookGroupTableData = res.data.data;
                    this.backupManualVolumeHookGroupTableData = JSON.parse(JSON.stringify(res.data.data));
                    this.manualpwm.count = res.data.count;
                }, error => {
                    this.$message.error('加载分组信息失败：' + error);
                });
            },
            fuzzyQueryManualVolumeGroupData() { //  挂接分组 - 模糊查询
                this.getManualVolumeHookGroupData();
            },
            autoVolumeSettingClickFun() {   //  一键成册设置
                this.autoVolumeSettingDialogVisible = true;
            },
            manualVolumeClickFun(opType, rowData) {    //  手工成册
                this.showRemarkMsg = false;
                this.manualVolumeCoverFormData = [];    //  手工成册 - 清空册封面数据
                this.manualVolumeDetailGroupForm.id = '';   //  册ID
                this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData = [];  //  册内分组信息
                this.backupManualVolumeDetailGroupData = [];    //  清空备份册内分组明细数据
                this.backupManualVolumeHookGroupTableData = []; //  清空备份已分组数据
                //  用户已勾选公司
                this.getUserCheckCompanyList().then(companyList => {
                    this.userCheckCompanyData = companyList;
                    if(opType == '1') {
                        if(companyList != null && companyList.length > 0) {
                            this.manualVolumeForm.companyId = companyList[0].id;

                            //  加载所选实体下已分组的组信息
                            this.getManualVolumeHookGroupData();
                        }
                    }
                });
                //  加载所选实体下已分组的组信息
                // this.getManualVolumeHookGroupData();
                if(opType == '2') {
                    this.disabledCompanyName = true;
                    // 根据册ID查询册信息
                    this.$refs.voucher.getVolumeDetailDataById(rowData.id).then(volumeDetailData => {
                        this.manualVolumeForm = volumeDetailData;
                        this.manualVolumeForm.id = volumeDetailData.book.id;
                        this.manualVolumeForm.companyId = volumeDetailData.book.companyId;
                        if(volumeDetailData.groupList && volumeDetailData.groupList.length > 0) {
                            volumeDetailData.groupList.forEach(group => {
                                group.groupDate = this.timestampFormatter(group.updateTime);
                            });
                        }
                        this.backupManualVolumeDetailGroupData = JSON.parse(JSON.stringify(volumeDetailData.groupList));
                        this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData = volumeDetailData.groupList;
                        let detailListData = this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData;
                      this.validManualVolumeDetailGroupData(detailListData).then(res => {
                        if (res) {
                          let idList = [];
                          detailListData.forEach(detail => {
                            idList.push(detail.id);
                          });
                          this.manualVolumeForm.groupIdList = idList;
                          this.manualVolumeHookGroupDialogVisible = false;

                        }
                      });
                        //  加载所选实体下已分组的组信息
                        this.getManualVolumeHookGroupData();
                    });

                    this.getBookConverInfo(rowData.id);
                } else {
                    this.disabledCompanyName = false;
                }
                this.manualVolumeForm.id = rowData.id;  //  册ID
                this.manualVolumeForm.opType = opType;
                this.manualVolumeDialogVisible = true;
            },
            getBookConverInfo(id) {
                if(!id) {
                    return;
                }
                fetchPost('/collation/book/getCollationBookCoverInfo', id).then(res => {
                    if(res.data.success) {
                        this.manualVolumeCoverFormData = res.data.obj;
                    } else {
                         this.$message.error('加载册封面信息失败' +  + res.data.message);
                    }
                }, error => {
                     this.$message.error('加载册封面信息失败' + error);
                });
            },
            tempSaveManualVolumeClickFun() {    //  手工成册 - 置为成册中
                let detailData = this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData;
                this.validManualVolumeDetailGroupData(detailData).then(res => {
                    if(res) {
                        this.tempSaveManualVolumeData();
                    }
                })
            },
            async tempSaveManualVolumeData() {
                await fetchPost('/collation/book/saveArchiveBooking', this.manualVolumeForm).then(res => {
                    if(res.data.success) {
                        this.$message.success('置为成册中成功！');
                        this.manualVolumeDialogVisible = false;
                        this.getArchiveBookData();  //  load table
                    } else {
                        this.$message.error('置为成册中失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('置为成册中失败：' + error);
                });
            },
            saveManualVolumeClickFun() {    //  手工成册 - 置为已成册
                let detailData = this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData;
                if(this.manualVolumeForm.book.remark && this.manualVolumeForm.book.remark.length > 50) {
                    this.showRemarkMsg = true;
                } else {
                    this.showRemarkMsg = false;
                }
                if(!this.showRemarkMsg) {
                    this.validManualVolumeDetailGroupData(detailData).then(res => {
                        if(res) {
                            this.manualVolumeForm.book.voucherNoStart = this.manualVolumeCoverFormData.voucherBeginNo;
                            this.manualVolumeForm.book.voucherNoEnd = this.manualVolumeCoverFormData.voucherEndNo;
                            this.saveManualVolumeData();
                        }
                    })
                }
            },

            doSettingBook(){
                if(this.volumeCount == '' || this.volumeConfig == ''){
                    this.$message.error('请完善设置信息再提交');
                    return;
                }
                let param = {count:this.volumeCount ,type:this.volumeConfig}
                this.doBookSettingConfig(param);
            },
            async saveManualVolumeData() {
                await fetchPost('/collation/book/saveArchiveBooked', this.manualVolumeForm).then(res => {
                    if(res.data.success) {
                        this.$message.success('置为已成册成功！');
                        this.manualVolumeDialogVisible = false;
                        this.getArchiveBookData();  //  load table
                    } else {
                        this.$message.success('置为已成册失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('置为已成册失败：' + error);
                });
            },
            async getBookSettingConfig() {
                await fetchPost('/trigger/getBookSetting').then(res => {
                    if(res.data.success) {
                        this.volumeConfig = res.data.obj.type;
                        this.volumeCount = res.data.obj.count;
                    } else {
                        this.$message.error('设置失败' + res.data.message);
                    }
                }, error => {
                    this.$message.error('设置失败' + error);
                });
            },

            async doBookSettingConfig(param) {
                await fetchPost('/trigger/addBookSetting',param).then(res => {
                    if(res.data.success) {
                        this.$message.success('设置成功');
                        this.autoVolumeSettingDialogVisible =false;
                    } else {
                        this.$message.error('设置失败' + res.data.message);
                        this.autoVolumeSettingDialogVisible =false;
                    }
                }, error => {
                    this.$message.error('设置失败' + error);
                });
            },
            manualVolumeHookGroupClickFun() {  //  手工成册 - 挂接组件
                if(this.manualVolumeForm.opType == '1') { //  手工成册
                    // this.manualVolumeDetailGroupForm.id = '';
                    // this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData = [];
                }
                this.manualVolumeHookGroupDialogVisible = true;
            },
            saveManualVolumeHookGroupClickFun() {   //  挂接分组 - 保存
                //  拼接册内组信息id list
                let detailData = this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData;
                //  校验册内组信息
                this.validManualVolumeDetailGroupData(detailData).then(res => {
                    if(res) {
                        let idList = [];
                        detailData.forEach(detail => {
                            idList.push(detail.id);
                        });
                        this.manualVolumeForm.groupIdList = idList;
                        this.manualVolumeHookGroupDialogVisible = false;
                        
                        fetchPost('/collation/book/getCollationBookSaveCover', idList.join(',')).then(res => {
                            if(res.data.success) {
                                this.manualVolumeCoverFormData = res.data.obj;
                            } else {
                                this.$message.error('加载册封面信息失败' +  + res.data.message);
                            }
                        }, error => {
                            this.$message.error('加载册封面信息失败' + error);
                        });
                        
                    }
                });
            },
            async validManualVolumeDetailGroupData(detailData) {  //  校验册内组信息是否为空
                if(!detailData || detailData.length == 0) {
                    this.$message.warning('册内组信息为空！');
                    return false;
                }
                return true;
            },
            manualVolumeHookGroupDialogClose() {    //  挂接分组 dialog 关闭触发事件
                let groupIdList = JSON.parse(JSON.stringify(this.manualVolumeForm.groupIdList));
                if(this.backupManualVolumeHookGroupTableData && this.backupManualVolumeHookGroupTableData.length > 0) {
                    this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData = JSON.parse(JSON.stringify(this.backupManualVolumeHookGroupTableData)).filter(detail => {
                        return groupIdList.indexOf(detail.id) != -1;
                    });
                    this.manualVolumeHookGroupTableData = JSON.parse(JSON.stringify(this.backupManualVolumeHookGroupTableData)).filter(detail => {
                        return groupIdList.indexOf(detail.id) == -1;
                    })
                } else {
                    this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData = JSON.parse(JSON.stringify(this.backupManualVolumeDetailGroupData));
                    this.manualVolumeHookGroupTableData = JSON.parse(JSON.stringify(this.backupManualVolumeHookGroupTableData));    //  已分组信息
                }
                this.manualVolumeHookGroupDialogVisible = false;
            },
            manualVolumeDetailGroupNodeClickFun(index) { //  左侧组明细 li节点 click
                let node = document.getElementById(this.manualVolumeDetailGroupNodeId + index);
                let detailData = this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData[index];
                detailData.index = index;
                if(!node.style.backgroundColor) {
                    node.style = "background-color: #ecf5ff;";
                    detailData.checked = true;
                } else {
                    node.style.backgroundColor = "";
                    detailData.checked = false;
                }
            },
            moveLeft() {    //  手工成册 - 挂接分组：左移
                let checkRows = this.$refs.manualVolumeHookGroupTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要左移的组信息！');
                    return;
                }
                //  根据rowIndex 升序
                checkRows.sort(function(a, b) {
                    return a.rowIndex- b.rowIndex;
                });
                this.addManualVolumeDetailGroupData(checkRows);  //  将选中组信息添加至册内
            },
            async addManualVolumeDetailGroupData(checkRows) {
                for (let i = checkRows.length - 1; i >= 0; i--) {
                    let row = checkRows[i];
                    row.groupDate = this.timestampFormatter(row.createTime);
                    row.checked = false;
                    this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData.push(row);
                    this.manualVolumeHookGroupTableData.splice(checkRows[i].rowIndex, 1);
                }
                //  将组信息根据记账凭证号升序排列
                this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData.sort(function(a, b) {
                    return a.voucherNo - b.voucherNo;
                });
            },
            moveRight() {
                let detailData = this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData;
                let checkDetailData = [];
                detailData.forEach(detail => {
                    if(detail.checked) {
                        checkDetailData.push(detail);
                    }
                });
                if(!checkDetailData || checkDetailData.length == 0) {
                    this.$message.warning('请选择需要右移的组信息！');
                    return;
                }
                for (let i = checkDetailData.length - 1; i >= 0; i--) {
                    this.manualVolumeDetailGroupNodeClickFun(checkDetailData[i].index);

                    this.manualVolumeHookGroupTableData.push(checkDetailData[i]);
                    this.manualVolumeDetailGroupForm.manualVolumeDetailGroupData.splice(checkDetailData[i].index, 1);
                }
            },
            cancelVolumeClickFun() {    //  取消成册
                let checkRows = this.$refs.archiveVolumeTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要取消成册的数据！');
                    return;
                }
                let idList = [];
                checkRows.forEach(row => {
                    idList.push(row.id);
                });
                fetchPost('/collation/book/restoreArchiveBook', idList.join(',')).then(res => {
                    if(res.data.success) {
                        this.$message.success('取消成册成功！');
                        this.getArchiveBookData();
                    } else {
                        this.$message.error('取消成册失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('取消成册失败：' + error);
                });
            },
            setBookedClickFun() {   //  置为已成册
                let checkRows = this.$refs.archiveVolumeTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要置为已成册的数据！');
                    return;
                }
                let idList = [];
                for (let i = 0; i < checkRows.length; i++) {
                    const row = checkRows[i];
                    if(row.status == '1') {
                        this.$message.warning('仅支持成册中状态下的档案修改为当前状态！');
                        return;
                    }
                    idList.push(row.id);
                }
                fetchPost('/collation/book/setArchiveBooked', idList.join(',')).then(res => {
                    if(res.data.success) {
                        this.$message.success('置为已成册成功！');
                        this.getArchiveBookData();
                    } else {
                        this.$message.error('置为已成册失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('置为已成册失败：' + error);
                });
            },
            setBookingClickFun() {  //  置为成册中
                let checkRows = this.$refs.archiveVolumeTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要置为成册中的数据！');
                    return;
                }
                let idList = [];
                for (let i = 0; i < checkRows.length; i++) {
                    const row = checkRows[i];
                    if(row.status == '0') {
                        this.$message.warning('仅支持已成册状态下的档案修改为当前状态！');
                        return;
                    }
                    idList.push(row.id);
                }
                fetchPost('/collation/book/setArchiveBooking', idList.join(',')).then(res => {
                    if(res.data.success) {
                        this.$message.success('置为成册中成功！');
                        this.getArchiveBookData();
                    } else {
                        this.$message.error('置为成册中失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('置为成册中失败：' + error);
                });
            },
            autoBookClickFun(){
            this.$confirm('是否一键快速成册？', '提示', { type: 'warning' }).then(res => {
                //  一键快速分组
                fetchPost('/trigger/autoBook', '').then(res => {
                    console.log(res)
                    if(res.data.success) {
                        this.$message.success("操作成功！刷新页面查看结果");
                    } else {
                        this.$message.error("一键成册失败！");
                    }
                });
            });
            },
            volumeLevelClickFun() {    //  册密级修改
                this.showLevelMsg = false;
                let checkRows = this.$refs.archiveVolumeTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要密级修改的册信息！');
                    return;
                }
                this.getUserSecretLevel().then(userLevel => {
                    if(!userLevel) {
                        this.$message.error('获取当前用户信息失败：用户未设置密级权限！');
                        return;
                    }
                    this.currUserSecretLevel = userLevel;
                    
                    let idList = [];
                    for (let i = 0; i < checkRows.length; i++) {
                        const row = checkRows[i];
                        //  用户无法修改密级权限比自身高的册密级权限
                        if(parseInt(this.currUserSecretLevel) > parseInt(row.secretLevel)) {
                            this.$message.error('不允许修改高于当前用户密级权限的册信息！');
                            return;
                        }
                        idList.push(row.id);
                    }
                    this.volumeLevelForm.count = checkRows.length;
                    this.volumeLevelForm.ids = idList.join(',');
                    this.volumeLevelDialogVisible = true;
                });
            },
            volumeLevelSelectChange(val) {
                if(val) {
                    this.showLevelMsg = false;
                }
            },
            saveVolumeLevelDataClickFun() { //  保存册密级
                if(!this.volumeLevelForm.volumeLevel) {
                    this.showLevelMsg = true;
                } else {
                    this.showLevelMsg = false;
                }
                if(!this.showLevelMsg) {
                    //  判断当前用户密级权限是否比修改后的册密级权限低
                    if(parseInt(this.volumeLevelForm.volumeLevel) < parseInt(this.currUserSecretLevel)) {
                        this.$confirm('当前修改的册密级权限比用户密级权限高，是否确认修改？', '提示', { type: 'warning' }).then(res => {
                            this.saveVolumeSecretLevelData();
                        });
                    } else {
                        this.saveVolumeSecretLevelData();
                    }
                }
            },
            saveVolumeSecretLevelData() {
                let params = this.volumeLevelForm;
                fetchPost('/collation/book/updateArchiveBookSecretLevel', params).then(res => {
                    if(res.data.success) {
                        this.volumeLevelDialogVisible = false;
                        this.$message.success('册密级修改成功！');
                        this.getArchiveBookData();
                    } else {
                        this.$message.error('册密级修改失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('册密级修改失败：' + error);
                });
            },
            viewVolumeDetails(bookId) { //  查看成册详情
                this.$refs.voucher.viewVolumeDetailsClickFun(bookId);
            },
            viewGroupDetailsClickFun(groupId) { //  查看详情 - 查看分组
                this.$refs.voucher.viewGroupDetailsClickFun(groupId);
            }
        }
    }
</script>
<style scoped>
    .table {
        width: 100%;
        font-size: 14px;
    }
    /* 手工成册dialog 样式 */
    .mv-voucher-container {
        padding-bottom: 15px;
    }
    .mv-voucher-container .mv-voucher-header {
        text-align: center;
        padding-bottom: 15px;
    }
    .mv-voucher-container .mv-voucher-header span{
        font-size: 20px;
        font-weight: bold;
    }
    .mv-voucher-container .mv-voucher-body {
        border: 1px solid #DCDFE6;
    }
    .mv-voucher-container .mv-voucher-body .mv-voucher-row {
        border-bottom: 1px solid #DCDFE6;
        line-height: 45px;
    }
    .mv-voucher-container .mv-voucher-body .mv-voucher-title {
        text-align: center;
        border-right: 1px solid #DCDFE6;
		background-color: #f8f8f8;
    }
    .mv-voucher-body .mv-voucher-row .mv-voucher-content {
        text-align: right;
        padding-right: 15px;
        border-right: 1px solid #DCDFE6;
    }
    .mv-voucher-container .mv-voucher-body .mv-voucher-content-span {
        padding: 0px 15px;
        font-weight: bold;
    }
    .mv-voucher-container .mv-voucher-footer {
        padding-top: 15px;
    }
    .mv-voucher-container .mv-voucher-footer .mv-voucher-footer-span {
        padding: 0px 15px;
        font-weight: 500;
    }

    /* 手工成册 - 挂接分组样式 */
    .mv-hook-group-container {
        height: 420px;
        overflow-y: auto;
    }
    .mv-hook-group-container ul{
        list-style-type: none;
    }
    .mv-hook-group-container ul li {
        height: 80px;
        border-bottom: 1px solid #DCDFE6;
    }
    .mv-hook-group-container .mv-hook-group-ind {
        width: 5%;
        height: 60px;
        line-height: 60px;
        padding-right: 10px;
        font-size: 14px;
        font-weight: bold;
    }
    .mv-hook-group-container .mv-hook-group-content {
        width: 75%;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
    }
    .mv-hook-group-container .mv-hook-group-icon {
        width: 20%;
        height: 60px;
        line-height: 65px;
        padding-left: 20px;
        text-align: right;
    }
    .mv-hook-group-container .mv-hook-group-icon i {
        color: #606266;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
    }
    .el-dialog {
        margin: 0 auto !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    .el-dialog__wrapper {
        display: flex ;
        align-items: center ;
    }
    .voucher-tag-title {
        font-size:14px;
        font-weight:bold;
        line-height: 25px;
        color: #66b1ff;
    }
    .voucher-tag-contmg {
        font-size: 12px;
        color:#909399;
    }
</style>